<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>

                <!-- Titulo -->
                <TituloPagina titulo="Usuários" />

                <!-- Filtro e Dialog de novo usuário -->
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                flat
                                solo
                                prepend-icon="search"
                                placeholder="Filtro"
                                v-model="search"
                                hide-details
                            ></v-text-field>
                            <UsuariosModal :reloadGrid="getUsuarios" />
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="usuarios.headers"
                                :search="search"
                                :items="usuarios.items"
                                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                                :loading="loading"
                                :no-data-text="semDados"
                                class="elevation-1"
                                item-key="name"
                            >
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.item.nome  }}</td>
                                    <td>{{ props.item.email }}</td>
                                    <td>{{ props.item.cargo }}</td>
                                    <td>
                                        <v-chip small v-for="perfil in props.item.perfis" :key="perfil">{{ perfil }}</v-chip>
                                    </td>
                                    <td class="no-wrap text-xs-right">
                                        <UsuariosModal :reloadGrid="getUsuarios" :id="props.item._id" :usuario="props.item" />
                                        <ExcluirModal :reloadGrid="getUsuarios" :id="props.item._id" :route="route" />
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import TituloPagina  from '@/components/crud/TituloPagina';
import ExcluirModal  from '@/components/crud/ExcluirModal';
import UsuariosModal from './UsuariosModal';

export default {
    name       : 'Usuarios',
    components : {
        TituloPagina,
        ExcluirModal,
        UsuariosModal
    },
    computed   : {
        semDados() {
            return this.loading ? 'Buscando informações...' : 'Nenhum usuário cadastrado';
        },
    },
    methods    : {
        getUsuarios() {
            this.loading = true;
            this.$axios.get(this.route).then(response => {
                this.usuarios.items = response.data.items
                this.loading = false;
            });
        }
    },
    data() {
        return {
            loading  : true,
            search   : '',
            route    : 'usuarios',
            usuarios : {
                headers : [
                    {
                        text  : 'Nome',
                        value : 'nome'
                    },
                    {
                        text  : 'Email',
                        value : 'email'
                    },
                    {
                        text  : 'Cargo',
                        value : 'cargo'
                    },
                    {
                        text  : 'Perfil',
                        value : 'perfis'
                    },
                    {
                        text  : 'Ações',
                        align :'center',
                        width : 1,
                        value : ''
                    }
                ],
                items   : []
            }
        };
    },
    mounted() {
        this.getUsuarios();
    }
};
</script>
